import { useNavigate } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Button } from "@mui/material";

import { PageHeader } from "../../components/layout";
import { LoadingSpinner } from "../../components/ui";
import { useInventoryTypes } from "../../hooks/inventory-type";
import { InventoryTypeDataGrid } from "../../components/grids";

export const InventoryTypesPage = () => {
  const {
    data: inventoryTypes,
    isLoading,
    isIdle,
    isError,
    error,
  } = useInventoryTypes();
  const navigate = useNavigate();

  if (isLoading || isIdle) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <h2>{error.message}</h2>;
  }

  return (
    <>
      <PageHeader
        title="Inventory Types"
        left={
          <Button
            onClick={() => navigate(-1)}
            startIcon={<ArrowBackIosIcon />}
            variant="contained"
          >
            Back
          </Button>
        }
      />
      <InventoryTypeDataGrid rows={inventoryTypes} loading={false} autoHeight />
    </>
  );
};
